"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MemoryDataStore = /** @class */ (function () {
    function MemoryDataStore() {
        this.data = new Map();
    }
    MemoryDataStore.prototype.get = function (key) {
        return this.data.get(key);
    };
    MemoryDataStore.prototype.set = function (key, value) {
        this.data.set(key, value);
    };
    MemoryDataStore.prototype.remove = function (key) {
        return this.data.delete(key);
    };
    MemoryDataStore.prototype.purge = function () {
        this.data.clear();
    };
    return MemoryDataStore;
}());
exports.MemoryDataStore = MemoryDataStore;
//# sourceMappingURL=memory-data-store.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/state-manager/data-store/memory-data-store.js
// module id = 1188
// module chunks = 8